import { Box } from '@mui/material'
import PropTypes from 'prop-types'

// Single flat shapes in currentColor, so each mark takes whatever colour its
// parent sets (the theme's primary) and still reads at favicon size. Sources:
// /mnt/project-files/brand (Joulelingo concept A, the speech bolt; Kilosight
// the insight bulb). Keep in sync with public/brands/*/favicon.svg.

// Speech bubble with a bolt cut out: "the language of energy".
const JOULELINGO_PATH =
    'M14 4h36a12 12 0 0 1 12 12v20a12 12 0 0 1-12 12H30l-11.4 10.6A1.5 1.5 0 0 1 16 57.5V48h-2A12 12 0 0 1 2 36V16A12 12 0 0 1 14 4zM36.5 8L21 29.5h10L27 44l16-21.5H33L36.5 8z'

// A light bulb with a bolt for its filament: electricity, and the
// light-bulb moment of seeing where it goes. One flat shape, bolt cut out.
const KILOSIGHT_PATH =
    'M32 4a21 21 0 0 0-12.5 37.9c2.3 1.9 3.5 4.3 3.5 7.1h18c0-2.8 1.2-5.2 3.5-7.1A21 21 0 0 0 32 4zM35.5 11L24.5 28h7.5l-3.5 13L40 23.5h-7.5l3-12.5z'

const KilosightShape = () => (
    <>
        <path fill="currentColor" fillRule="evenodd" d={KILOSIGHT_PATH} />
        <rect
            x="23"
            y="52"
            width="18"
            height="4.5"
            rx="2.25"
            fill="currentColor"
        />
        <rect
            x="26"
            y="58.5"
            width="12"
            height="4.5"
            rx="2.25"
            fill="currentColor"
        />
    </>
)

const SHAPES = {
    joulelingo: () => (
        <path fill="currentColor" fillRule="evenodd" d={JOULELINGO_PATH} />
    ),
    kilosight: KilosightShape
}

const BrandMark = ({ brandKey, size = 32, sx }) => {
    const Shape = SHAPES[brandKey]
    if (!Shape) return null
    return (
        <Box
            component="svg"
            viewBox="0 0 64 64"
            aria-hidden="true"
            focusable="false"
            data-brand-mark={brandKey}
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                color: 'primary.main',
                ...sx
            }}
        >
            <Shape />
        </Box>
    )
}

BrandMark.propTypes = {
    brandKey: PropTypes.string.isRequired,
    size: PropTypes.number,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default BrandMark
